import { render, staticRenderFns } from "./ConfirmDepositDialog.vue?vue&type=template&id=57d60e91"
import script from "./ConfirmDepositDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDepositDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports